import { questionnaireGql } from '../../../gql-gen/questionnaire'

export const CREATE_MATRIX_ROW = questionnaireGql(/* GraphQL */ `
  mutation createMatrixRowV2($input: CreateMatrixRowV2Input!) {
    createMatrixRowV2(input: $input) {
      ...DraftMatrixRow
    }
  }
`)
